import React, { useEffect, useState } from "react";
import firebase from "firebase";
import styled from "styled-components";
import { completeYouTubeAuth } from "../../../../database/community/youtubeConnection";

const Screen = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111;
  color: #fff;
  font-family: var(--font-sans, system-ui, sans-serif);
  padding: 24px;
`;
const Card = styled.div`
  max-width: 380px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
`;
const Body = styled.div`
  font-size: 14px;
  color: #aaa;
  line-height: 1.5;
`;

const YouTubeCallback: React.FC = () => {
  const [phase, setPhase] = useState<"working" | "done" | "error">("working");
  const [message, setMessage] = useState("Finishing your YouTube connection…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code") || "";
    const state = params.get("state") || "";
    const oauthError = params.get("error_description") || params.get("error");
    if (oauthError || !code || !state) {
      setPhase("error");
      setMessage(
        oauthError
          ? `YouTube returned an error: ${oauthError}`
          : "Missing code or state from YouTube. Try connecting again."
      );
      return;
    }
    let handled = false;
    const unsub = firebase.auth().onAuthStateChanged(async (user) => {
      if (handled || !user) return;
      handled = true;
      unsub();
      try {
        const result = await completeYouTubeAuth({ code, state });
        setPhase("done");
        setMessage(
          `${result.channelTitle || "YouTube"} connected. You can close this window.`
        );
        setTimeout(() => {
          if (window.opener) window.close();
        }, 1200);
      } catch (e: any) {
        setPhase("error");
        setMessage(e?.message || "Could not finish the YouTube connection.");
      }
    });
    return () => unsub();
  }, []);

  return (
    <Screen>
      <Card>
        <Title>
          {phase === "working"
            ? "Connecting YouTube…"
            : phase === "done"
              ? "All set"
              : "Something went wrong"}
        </Title>
        <Body>{message}</Body>
        {phase !== "working" ? (
          <Body>
            <a href="/" style={{ color: "#fff" }}>
              Back to the admin
            </a>
          </Body>
        ) : null}
      </Card>
    </Screen>
  );
};

export default YouTubeCallback;
